module.exports = __webpack_public_path__ + "img/pro_feature_private_documents.076e8bb.png";